<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        :icon="icon" 
        v-bind:show.sync="dialog"
        maxWidth="40%"
    >
        <template v-slot:form>
            <v-container>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <sys-select-periodicity
                                :model.sync="model.periodicity_type_id"
                                :error="errors.periodicity_type_id && errors.length > 0"  
                                :errors="errors.periodicity_type_id"
                                label="Periodicidade*"
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <sys-select-day-of-week
                                :model.sync="model.day_of_week_id"
                                :error="errors.length > 0"  
                                :errors="errors.day_of_week_id"
                                label="Dia*"
                                dense
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <sys-select-date-mask-type
                                :model.sync="model.date_mask_type_id"
                                :error="errors.date_mask_type_id && errors.length > 0"  
                                :errors="errors.date_mask_type_id"
                                label="Máscara*"
                                dense
                                show-add
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <emc-calendar-date-picker2 
                                    :model.sync="model.date" 
                                    label="Data*" 
                                    :errorMessages="errors.date"
                                    :show="dialog"
                                    dense
                                />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <sys-select-shift
                                :model.sync="model.shift_id"
                                :error="errors.length > 0"  
                                :errors="errors.shift_id"
                                label="Turno"
                                clearable
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <emc-calendar-time-picker 
                                dense 
                                :error="!!errors.hour_start" 
                                :errors="errors['hour_start']" 
                                :time.sync="model.hour_start" 
                                label="Início"
                                clearable
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <emc-calendar-time-picker 
                                dense 
                                :error="!!errors.hour_end" 
                                :errors="errors['hour_end']" 
                                :time.sync="model.hour_end" 
                                label="Fim"
                                clearable
                            />
                        </v-col>
                    </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: "SysGridDateMaskRegister",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
        
    }),
    created(){
       
    },

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                this.error = false;
                this.errors = {};

                if(!this.model.id){
                    this.model.active = 1;
                }

            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-database-plus"
        },
        title: {
            type: String,
            default: "Máscara de Datas"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('grid', ['ActionUpdateDateMask', 'ActionStoreDateMask']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            if(edit) {
                this.ActionUpdateDateMask(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionStoreDateMask(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

    }
}
</script>